<template>
  <v-navigation-drawer permanent floating width="250" :model-value="documents && documents.length && quarter_available">
    <template v-slot:prepend>
      <v-skeleton-loader v-if="!documents" type="list-item-two-line" width="100%" />
      <v-alert v-else title="ДОКУМЕНТЫ" border="bottom" rounded="0" border-color="light-green-lighten-4">
        <span v-if="selected && selected.length > 0">{{ selected.length }} /</span> <span v-if="documents">{{ documents.length }}</span>
      </v-alert>
    </template>

    <template v-if="documents && documents.length">
      <template v-for="doc in documents" :key="doc">
        <v-card
            density="compact"
            class="my-card"
            elevation="0" rounded="0"
            v-if="is_filtered(doc)"

            v-on:click="sd_document(doc)"
            v-on:pointerup="del_timer()"
            v-on:pointerdown="start_timer(doc)"
            :color="get_card_color(doc)"
        >
          <template v-slot:prepend>
            <p style="font-size: 12px;">
              №{{ doc.number }}
              <span style="vertical-align: super; font-size: smaller" v-if="doc.example && doc.example > 1">
              ({{doc.example}})
            </span>
            </p>
          </template>
          <template v-slot:append>
            {{ doc.duration }}
            <v-avatar :style="get_gradient(doc)" variant="tonal" color="grey" size="20">
              <v-avatar variant="flat" size="22" class="font-weight-bold">
                <!-- <v-icon :icon="['fas', get_work_type_icon(doc.type)]" />-->
              </v-avatar>
            </v-avatar>
          </template>
          <template v-slot:subtitle v-if="doc.object.name">
            {{ doc.object.name }}
            <v-tooltip activator="parent" v-if="doc.object.name.length > 20">
              {{ doc.object.name }}
            </v-tooltip>
          </template>
        </v-card>
      </template>
    </template>
  </v-navigation-drawer>

  <v-navigation-drawer location="end" permanent floating v-if="document_preview" width="400">
    <v-card
        density="compact"
        class="my-card"
        elevation="0" rounded="0"
    >
      <template v-slot:text>
        <v-alert rounded="xl" class="mb-5">
          <template v-slot:title>
            {{ document_preview.object.name }}
          </template>
          <template v-slot:text>
            <span v-if="document_preview.location"><v-icon :icon="['fas', 'location-dot']" /> {{ document_preview.location.name }}<br></span>
            З.Н. №: {{ document_preview.number }} / {{ document_preview.period }}<br>
            {{ document_preview.chief.name }}
          </template>

        </v-alert>
        <v-row>
          <v-col>
            Трудозатраты {{ document_preview.duration }} ч.<br>
            {{ document_preview.type.name }}<br>
            <v-divider class="my-1"/>
            <span>{{ document_preview.agent.name }}</span>
          </v-col>
          <v-col cols="12" md="6" v-if="document_preview.agent.logo">
            <v-img width="100%" :src="document_preview.agent.logo" />
          </v-col>
        </v-row>
        <pre v-if="additional">
          {{ document_preview }}
        </pre>
      </template>
    </v-card>
    <template v-slot:append>
      <v-sheet class="ma-2 d-flex justify-space-between">
        <v-checkbox-btn inset v-model="additional" label="DEV" hide-details density="compact" style="opacity: 0.1;"/>
        <v-btn color="red" variant="tonal" flat rounded="xl" v-on:click="document_preview = null">
          ЗАКРЫТЬ
        </v-btn>
      </v-sheet>
    </template>
  </v-navigation-drawer>

  <v-dialog max-width="500" v-model="dialog.shown" persistent style="backdrop-filter: blur(10px)">
    <template v-slot:default>
      <v-card
          density="compact"
          class="my-card"
          elevation="10" rounded="xl"
      >
        <v-card-title v-if="dialog.doc.agent.logo">
          <v-sheet height="70">
            <v-img :src="dialog.doc.agent.logo" />
          </v-sheet>
        </v-card-title>
        <v-card-title>
          {{ dialog.doc.object.name }}
        </v-card-title>
        <v-card-subtitle>
           <span v-if="dialog.doc.location">
            <v-icon :icon="['fas', 'location-dot']" /> {{ dialog.doc.location.name }}<br>
          </span>
          З.Н. №: {{ dialog.doc.number }}<br>
          Трудозатраты: {{ dialog.doc.duration }} ч.<br>
          {{ dialog.doc.type.name }}<br>
          Периодичность: {{ dialog.doc.period }}<br>
        </v-card-subtitle>
        <v-card-actions>
          <v-sheet class="ma-2">
            <v-btn color="red" variant="tonal" block flat rounded="xl" v-on:click="dialog.shown = false">
              ЗАКРЫТЬ
            </v-btn>
          </v-sheet>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>

  <v-row v-if="calendar">
    <v-col cols="12" lg="12">
      <QQuarterCard :editable="quarter_available"/>
    </v-col>
  </v-row>
  <v-skeleton-loader v-if="!calendar" type="table-tbody" />

</template>

<script>
import moment from "moment"
import { CurrentYear } from "@/store/zn_planner/CurrentYear"
import { CurrentYearCalendar } from "@/store/zn_planner/CalendarOfYear"
import { TokenGUIDStore } from "@/store/global/SessionStore"
import QQuarterCard from "@/views/a_planner/cards/quarter.vue"
import { Documents, OriginalDocuments, SelectedDocs } from "@/store/zn_planner/Documents"
import { ZN_SelDoc } from "@/store/a_planner/SelectedDOC";
import { UserStore } from "@/store/GigaUser";
import {ZN_Filters, ZN_FiltersFrom1C} from "@/store/zn_planner/Filters";
import route_check from "@/libs/route_check";

export default {
  name: 'A_Planner_Q',
  components: { QQuarterCard },
  async beforeMount() {
    route_check('/autoplanner/district').then(async res => {
      if (res) {
        this.check_props()
        await this.get_docs()
      } else {
        this.$router.push({ name: 'home' })
      }
    })
  },
  data() {
    return {
      additional: false,
      dialog: {
        doc: null,
        shown: false
      },
      timer: null
    }
  },
  methods: {
    moment,
    get_gradient: function (doc) {
      let period = doc.period
      let s
      switch (period) {
        case 'Квартал':
          s = 100 / 4
          break
        case 'Полугодие':
          s = 100 / 2
          break
        case 'Год':
          s = 100
          break
        case 'Месяц':
          s = 100 / 12
          break
        default:
          s = 0
          break
      }
      return `background: conic-gradient(${'#c5c5c5'} 0% ${s}%, ${'rgba(255,255,255,0)'} ${s}% 100%) !important`
    },/*
    get_gradient_duration: function () {
      return `background: conic-gradient(${'#c5c5c5'} 0% ${this.duration_mod_percent}%, ${'rgba(255,255,255,0)'} ${this.duration_mod_percent}% 100%) !important`
    },*/
    start_timer: function (doc) {
      this.timer = setTimeout(() => {
        this.dialog.shown = true
        this.dialog.doc = doc
      }, 600)
    },
    del_timer: function () {
      clearTimeout(this.timer)
    },
    get_card_color: function (doc) {
      if (this.selected.filter(d => d.guid === doc.guid).length > 0) {
        return `grey-lighten-2`
      } else {
        if (doc.type.name === 'Испытания') {
          return 'amber-lighten-5'
        } else if (doc.type.name === 'Техническое обслуживание')  {
          return 'gery-lighten-2'
        } else {
          return null
        }
      }
    },
    get_color: function (type) {
      switch (type) {
        case 'Испытания': return 'red'
        case 'Техническое обслуживание': return 'white'
        default: return 'black'
      }
    },
    sd_document: function (doc) {
      if (this.selected.filter(d => d.guid === doc.guid ).length > 0) {
        this.selected.splice(this.selected.findIndex(d => d.guid  === doc.guid), 1)
      } else {
        this.selected.push(doc)
      }
    },
    close_dialog: function () {
      this.dialog = {
        doc: null,
        shown: false
      }
    },
    check_props: function () {
      if (!this.$route.params.guid || !this.$route.params.year || !this.$route.params.quarter) {
        this.$router.push({ name: 'a__planner__district' })
      }
    },
    get_docs: async function () {
      this.documents = null
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/ZN_GetPlannerData`
      let raw = {
        year: this.$route.params.year,
        quarter: this.$route.params.quarter,
        district: this.$route.params.guid
      }

      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            this.calendar = result.calendar
            this.documents = result.documents
            this.documents_o = result.documents
            this.filters_from1C = result.filters
            console.log(this.filters_from1C)
          }).catch(err => {
            console.error(err)
          })
    },
    c_image: function (guid) {
      let image
      try {
        image = require(`@/components/Reports/images/reports/contracts/${guid}.png`)
      } catch (err) {
        //console.log(`%cВыбранный контракт не имеет загруженного логотипа!\n\n%c${guid}.png`, 'background: #f00; color: #fff', 'background: transparent; color: #000')
      }
      if (image) return image
      return null
    },
    is_filtered(doc) {
      if (this.filters) {
        let agents = this.filters.agents
        let objects = this.filters.objects
        let types = this.filters.types
        let period = this.filters.period
        let chief = this.filters.chiefs

        let has_agents = agents.length > 0 ? agents.includes(doc.agent.guid) : true
        let has_objects = objects.length > 0 ? objects.includes(doc.object.guid) : true
        let has_types = types.length > 0 ? types.includes(doc.type.guid) : true
        let has_period = period.length > 0 ? period.includes(doc.period) : true
        let has_chief = chief.length > 0 ? chief.includes(doc.chief.guid) : true

        return has_agents && has_objects && has_types && has_period && has_chief
      } else {
        return true
      }
    }
  },
  computed: {
    quarter_available() {
      if (this.year > parseInt(moment().format('YYYY'))) {
        return true
      } else if (this.year === parseInt(moment().format('YYYY'))) {
        return parseInt(moment().quarter()) <= this.$route.params.quarter;
      } else if (this.year < parseInt(moment().format('YYYY'))) {
        return false
      } else {
        return false
      }
    },
    filters: {
      get() {
        return ZN_Filters().get()
      },
      set(value) {
        ZN_Filters().set(value)
      }
    },
    filters_from1C: {
      get() {
        return ZN_FiltersFrom1C().get()
      },
      set(value) {
        ZN_FiltersFrom1C().set(value)
      }
    },
    year: {
      get() {
        return CurrentYear().get()
      },
      set(value) {
        CurrentYear().set(value)
        this.update_route()
      }
    },
    document_preview: {
      get() {
        return ZN_SelDoc().get()
      },
      set(value) {
        ZN_SelDoc().set(value)
      }
    },
    calendar: {
      get() {
        return CurrentYearCalendar().get()
      },
      set(value) {
        CurrentYearCalendar().set(value)
      }
    },
    selected: {
      get() {
        return SelectedDocs().get()
      },
      set(value) {
        SelectedDocs().set(value)
      }
    },
    documents: {
      get() {
        return Documents().get()
      },
      set(value) {
        Documents().set(value)
      }
    },
    documents_o: {
      get() {
        return OriginalDocuments().get()
      },
      set(value) {
        OriginalDocuments().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    },
    district() {
      return this.$route.params.guid
    },
    user: {
      get() {
        return UserStore().get()
      },
      set(value) {
        UserStore().set(value)
      }
    }
  }
}

</script>

<style scoped>
.my-card {
  transition: 0.3s;
}
</style>
